<template>
  <transition name="pa-simple-fade">
    <div class="pa-pod-room-characters" v-if="couldVisibleCharacterList">
      <div class="character-slider">
        <ul class="character-list" id="connection-character-list">
          <li v-for="character in characterList"  :key="character.id">
            <CharacterIcon :character="character" />
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

export default {
  components : {
    CharacterIcon
  },

  data(){
    return {
      characterList : []
    };
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    },

    couldVisibleCharacterList(){
      if(
        (typeof this.joinedPodRoomList !== 'undefined') &&
        (this.podRoomType === 'private') && (this.joinedPodRoomList.length > 0)
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    joinedPodRoomList : {
      handler(){
        this.getCharacterList();
      },
      immediate: false
    },

    podRoomId : {
      handler(){
        this.getCharacterList();
      },
      immediate: false
    },
  },

  methods : {
    getCharacterList(){
      if(typeof this.podRoomId === 'undefined') return;
      if(typeof this.joinedPodRoomList === 'undefined') return;
      
      for(let room of this.joinedPodRoomList){
        if(room.id === this.podRoomId){
          if(typeof room.characterList !== 'undefined'){
            this.characterList = room.characterList;
          }

          return;
        }
      }
    }
  }
}
</script>

<style lang="scss">
.pa-pod-room-characters{
  // position: relative;
  // z-index: 100;

  background-color:#C6AC8C;
  width:100%;
  overflow-x: auto;
  margin-top:-.5rem;
  margin-bottom:.6rem;

  .character-slider{
    background-color:#C6AC8C;
    padding:.5rem 0;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    ul.character-list{
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: nowrap;
      overflow-x: auto;
      width: auto;
      padding:0;

      &::-webkit-scrollbar {
        display: none;
      }

      li{
        margin:0;
        padding:0 .6rem 0 0;
        text-align: center;
        width:auto;
        line-height: 1;

        &:first-child{
          padding-left:.7rem;
        }

        &:last-child{
          padding-right:.7rem;
        }

        .pa-character-icon{
          background-color:#C4A27A;
          width:3rem;
          height:3rem;
          line-height: 2.8rem;
        }
        
        img, svg{
          width:3rem;
        }
      }
    }
  }
}
</style>